"use client";

import { createParser, createSerializer } from "nuqs";
import { FlightParsers, FlightSerializers } from "@/feature/flight/search/lib/search";
import {
  DEFAULT_FLIGHT_FORM_VALUES,
  type IDecodedFlightSearch,
} from "@/feature/flight/search/types/search";

export type { IDecodedFlightSearch };

export const parseAsTripType = createParser({
  parse: FlightParsers.tripType,
  serialize: (v) => v,
});

export const parseAsCabin = createParser({
  parse: FlightParsers.cabin,
  serialize: FlightSerializers.cabin,
});

export const parseAsFareType = createParser({
  parse: FlightParsers.fareType,
  serialize: FlightSerializers.fareType,
});

export const parseAsPassengers = createParser({
  parse: FlightParsers.passengers,
  serialize: FlightSerializers.passengers,
});

export const parseAsFlights = createParser({
  parse: FlightParsers.flights,
  serialize: FlightSerializers.flights,
});

export const parseAsChildrenAges = createParser({
  parse: FlightParsers.childrenAges,
  serialize: FlightSerializers.childrenAges,
});

export const flightSearchParamsConfig = {
  trip: parseAsTripType.withDefault(DEFAULT_FLIGHT_FORM_VALUES.tripType),
  route: parseAsFlights.withDefault([]),
  fare: parseAsFareType.withDefault(DEFAULT_FLIGHT_FORM_VALUES.fareType),
  pax: parseAsPassengers.withDefault(DEFAULT_FLIGHT_FORM_VALUES.passengers),
  cabin: parseAsCabin.withDefault(DEFAULT_FLIGHT_FORM_VALUES.cabin),
  ages: parseAsChildrenAges.withDefault([]),
};

export const serializeFlightSearchParams = createSerializer(flightSearchParamsConfig);




